import React from 'react';

import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  ModalBodyProps,
} from '@chakra-ui/react';

type DrawerProps = Omit<
  React.ComponentProps<typeof Drawer>,
  'children' | 'isOpen' | 'onClose'
>;

type Props = DrawerProps & {
  drawerTitle: string;
  children: React.ReactNode;
  bodyProps?: ModalBodyProps;
  drawerFooter?: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

export function SimpleDrawer(props: Props) {
  const {
    drawerTitle,
    children,
    bodyProps,
    drawerFooter,
    isOpen,
    onClose,
    ...otherProps
  } = props;
  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right" {...otherProps}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{drawerTitle}</DrawerHeader>
        <DrawerBody {...bodyProps}>{children}</DrawerBody>
        {drawerFooter ? <DrawerFooter>{drawerFooter}</DrawerFooter> : null}
      </DrawerContent>
    </Drawer>
  );
}
